import { render, staticRenderFns } from "./footmenu.vue?vue&type=template&id=62a1bc0f&scoped=true&"
import script from "./footmenu.vue?vue&type=script&lang=js&"
export * from "./footmenu.vue?vue&type=script&lang=js&"
import style0 from "./footmenu.vue?vue&type=style&index=0&id=62a1bc0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a1bc0f",
  null
  
)

export default component.exports